import {useQuery} from 'react-query';
import {GmlExportApi, LayerSchemaVO} from '../api';

export const CACHE_KEY_SCHEMA_TEMPLATES = 'CACHE_KEY_SCHEMA_TEMPLATES';

export const useLayerSchemaTemplates = () => {
    return useQuery<LayerSchemaVO[]>(
        [CACHE_KEY_SCHEMA_TEMPLATES],
        async () => (await GmlExportApi.nactiStrukturuXsd()).data,
    );
};
